import { Moment } from 'moment';
import MomentUtils from '@date-io/moment'

export class MomentUTCUtils extends MomentUtils {

  format(date: Moment, formatString: string) {
    return this.moment.utc(date).format(formatString);
  }

}